import { render, staticRenderFns } from "./FuncDefaultDev.vue?vue&type=template&id=4bc3452a&scoped=true"
import script from "./FuncDefaultDev.vue?vue&type=script&lang=js"
export * from "./FuncDefaultDev.vue?vue&type=script&lang=js"
import style0 from "./FuncDefaultDev.vue?vue&type=style&index=0&id=4bc3452a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc3452a",
  null
  
)

export default component.exports